export var Source;
(function (Source) {
    Source[Source["MEITUAN_APP"] = 1] = "MEITUAN_APP";
    // 美团APP
    Source[Source["DIANPING_APP"] = 2] = "DIANPING_APP";
    // 点评APP
    Source[Source["WECHAT_MEITUAN_MINI"] = 3] = "WECHAT_MEITUAN_MINI";
    // 微信美团小程序
    Source[Source["WECHAT_HOTEL_MINI"] = 4] = "WECHAT_HOTEL_MINI";
    // 微信酒店+小程序
    Source[Source["WECHAT_DIANPING_MINI"] = 5] = "WECHAT_DIANPING_MINI"; // 微信点评小程序
})(Source || (Source = {}));
/**
 * 奖品类型枚举
 */
export var RewardType;
(function (RewardType) {
    RewardType[RewardType["Next"] = 1] = "Next";
    // next券
    RewardType[RewardType["God"] = 2] = "God";
    // god券
    RewardType[RewardType["Points"] = 3] = "Points";
    // 积分
    RewardType[RewardType["Physical"] = 4] = "Physical";
    // 实物
    RewardType[RewardType["Package"] = 9] = "Package"; // 奖励包
})(RewardType || (RewardType = {}));
/**
 * 业务线枚举
 */
export var BizLine;
(function (BizLine) {
    BizLine[BizLine["Default"] = 0] = "Default";
    // 默认
    BizLine[BizLine["Hotel"] = 1] = "Hotel";
    // 境内住宿
    BizLine[BizLine["Air"] = 2] = "Air";
    // 机票
    BizLine[BizLine["Train"] = 3] = "Train";
    // 火车票
    BizLine[BizLine["HomeStay"] = 4] = "HomeStay";
    // 民宿
    BizLine[BizLine["Ticket"] = 5] = "Ticket";
    // 门票
    BizLine[BizLine["Vacation"] = 6] = "Vacation";
    // 度假
    BizLine[BizLine["OverseaHotel"] = 7] = "OverseaHotel";
    // 境外住宿
    BizLine[BizLine["Car"] = 8] = "Car";
    // 打车
    BizLine[BizLine["OverseaTicket"] = 9] = "OverseaTicket"; // 境外门票
})(BizLine || (BizLine = {}));
export const BizLineDesc = {
    [BizLine.Hotel]: '酒店',
    [BizLine.Air]: '机票',
    [BizLine.Train]: '火车票',
    [BizLine.HomeStay]: '民宿',
    [BizLine.Ticket]: '门票',
    [BizLine.Vacation]: '度假',
    // [BizLine.OverseaHotel]: '境外住宿',
    [BizLine.Car]: '打车'
    // [BizLine.OverseaTicket]: '境外门票',
};
/**
 * 金额类型枚举
 */
export var AmountType;
(function (AmountType) {
    AmountType[AmountType["FullReduction"] = 1] = "FullReduction";
    // 满减
    AmountType[AmountType["Discount"] = 2] = "Discount"; // 折扣
})(AmountType || (AmountType = {}));
/**
 * 奖励状态枚举
 */
export var PrizeStatus;
(function (PrizeStatus) {
    PrizeStatus[PrizeStatus["CAN_DRAW"] = 1] = "CAN_DRAW";
    // 可领取
    PrizeStatus[PrizeStatus["CANNOT_DRAW"] = 2] = "CANNOT_DRAW";
    // 不可领取
    PrizeStatus[PrizeStatus["NOT_USED"] = 3] = "NOT_USED";
    // 未使用
    PrizeStatus[PrizeStatus["USED"] = 4] = "USED";
    // 已使用
    PrizeStatus[PrizeStatus["EXPIRED"] = 5] = "EXPIRED";
    // 已过期
    PrizeStatus[PrizeStatus["PRE_DRAW"] = 6] = "PRE_DRAW";
    // 预先领取
    PrizeStatus[PrizeStatus["DRAWN"] = 7] = "DRAWN";
    // 已领取
    PrizeStatus[PrizeStatus["NO_INVENTORY"] = 8] = "NO_INVENTORY"; // 无库存
})(PrizeStatus || (PrizeStatus = {}));
export const PrizeStatusDesc = {
    [PrizeStatus.CAN_DRAW]: '领取',
    [PrizeStatus.CANNOT_DRAW]: '不可领',
    [PrizeStatus.NOT_USED]: '去使用',
    [PrizeStatus.USED]: '已使用',
    [PrizeStatus.EXPIRED]: '已过期',
    [PrizeStatus.PRE_DRAW]: '领取',
    [PrizeStatus.DRAWN]: '去使用',
    [PrizeStatus.NO_INVENTORY]: '不可领'
};
/**
 * 活动状态枚举-前端维护
 */
export var ActivityState;
(function (ActivityState) {
    ActivityState[ActivityState["END"] = 0] = "END";
    // 活动已结束
    ActivityState[ActivityState["CAN_RESERVE"] = 1] = "CAN_RESERVE";
    // 可预约
    ActivityState[ActivityState["RESERVED"] = 2] = "RESERVED";
    // 已预约
    ActivityState[ActivityState["UNRESERVED_CAN_DRAW"] = 3] = "UNRESERVED_CAN_DRAW";
    // 未抽奖可抽奖
    ActivityState[ActivityState["DRAWN_NO_CHANCES"] = 4] = "DRAWN_NO_CHANCES";
    // 已抽奖没有抽奖次数
    ActivityState[ActivityState["DRAWN_HAS_CHANCES"] = 5] = "DRAWN_HAS_CHANCES";
    // 已抽奖有抽奖次数
    ActivityState[ActivityState["REWARD_PACKAGE"] = 6] = "REWARD_PACKAGE"; // 抽中5折券包
})(ActivityState || (ActivityState = {}));
/**
 * 任务类型
 */
export var TaskType;
(function (TaskType) {
    TaskType[TaskType["INVITE_TASK"] = 1002] = "INVITE_TASK"; // 邀请助力任务
})(TaskType || (TaskType = {}));
